<template>
    <v-app style="height: 5rem" class="vuetify-style">
        <v-color-picker v-model="color" style="height: 5rem" dot-size="50" hide-canvas mode="hexa"></v-color-picker>
    </v-app>
</template>

<script>
export default {
    name: 'colorPicker',
    data: () => ({
        color: '#FF00FF',
    }),
}
</script>

<style scoped>
.vuetify-style:deep(.v-color-picker__input) {
    opacity: 0;
}
</style>
